module.exports = __webpack_public_path__ + "img/kjrc-cyzk.964214c4.jpg";